import { CircleQuestionMark } from 'lucide-react';
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import { useVisualViewportHeight } from './hook.js';

export const Faq = ({ id = null }) => {
    const vvHeight = useVisualViewportHeight();
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);

    const sections = [
        {
            name: "aomeについて", // about aome
            qa: [
                {
                    question: "他の英語アプリと、何が違いますか？", // how is it different
                    answer: "英語は、ルールを覚えて身につくものではないと考えています。 本物の言葉に何度も出会って、深く観察すること。そして、言いたいことを、自分の力で言葉にしようと試みること。その両方でしか育たない感覚が、英語を話せるかどうかを決めています。 aomeは、その二つだけのためにつくられています。 読むものは、学習用ではなく、英語圏で実際に読まれ、観られているものです。レベル分けはせず、あなたが知っている言葉を一語ずつ見て選びます。知らない言葉が20%前後になるように。楽ではありませんが、言葉が根づくのは、その密度です。 読みながら浮かんだ問いは、その場でアオメに訊けます。書くときは、語彙の制限がありません。言いたいことに手を伸ばして、届かなかった距離を、そのまま見せてくれます。 そして、読むことも、書くことも、思い出すことも、aomeの中では同じ一つの記憶から生まれています。今日出会った言葉が、明日読むものを変えていきます。 同じ道を歩く人は、ふたりといません。",
                },
                {
                    question: "英語初心者でも使えますか？", // can beginners use it
                    answer: "「レベルが足りない」ということはありません。aomeは、あなたが知っている言葉に合わせて選ぶからです。語彙がまだ少ない方には、基本の言葉から始めていただけます。ただ、どの段階でも、少し難しいと感じるはずです。それは、そう設計しています。"
                },
                {
                    question: "どのくらいで話せるようになりますか？", // how long does it take to become fluent
                    answer: "「話せる」がどこからなのか、実は誰にも決められません。ネイティブスピーカーであっても、言葉が完成することはないからです。 ただ、実感としては、はっきり進みます。言えることが少しずつ増え、言葉を探す時間が短くなり、やがて、言いたいことがそのまま英語で出てくる場面が増えていきます。 数ヶ月で、そう感じる方は多いはずです。そして、その先も、終わりはありません。"
                },
                {
                    question: "1日どのくらい必要ですか？", // how much spend do i need to spend a day
                    answer: "決まりはありません。ホームに、その日のタスクが並びます。すべてでも、一つだけでも構いません。 まとめて長時間より、短くても毎日のほうが、言葉は根づきます。 続けられるか、不安です。 英語を一度諦めた経験がある方は、少なくないはずです。それは、意志の問題ではないと考えています。 何をすればいいのかが曖昧なとき、人は続けられません。aomeには、その日にやることが並んでいます。読む、問う、書く、思い出す。迷うことはありません。 連続記録のようなものもありません。休んでも、失われるものはありません。出会った言葉はそのまま残っていて、忘れかけた頃に、また戻ってきます。 焦らなくて大丈夫です。あなたのペースで。"
                },
                {
                    question: "TOEICなどの試験対策になりますか？", // does it help with exams
                    answer: "試験対策のためのサービスではありません。出題傾向に合わせた演習はご用意していません。 ただ、英語が読めて、聞けて、言いたいことが言えるようになれば、点数は自然についてきます。それは、英語ができる人が試験で困らないのと同じことです。 私たちが目指しているのは、その逆ではありません。点数のための英語ではなく、使える英語です。使えるようになった結果として、点数もついてくる。順番が違うだけです。"
                },
            ]
        }, {
            name: "料金とトライアル", // pricing and trial
            qa: [
                {
                    question: "無料トライアルに、クレジットカードは必要ですか？", // do i need credit card for free trial
                    answer: "必要ありません。14日間、カードの登録なしでお使いいただけます。"
                },
                {
                    question: "トライアルが終わると、どうなりますか？", // what happens when trial ends
                    answer: "自動的に請求されることはありません。カードを登録していないためです。 続ける場合は、ご自身でプランをお選びください。それまでに出会った言葉も、記録も、そのまま残ります。"
                },
                {
                    question: "創設メンバー価格は、ずっと続きますか？", // does founding price stay the same forever
                    answer: "はい。最初の100名様は、ずっとこの価格のままです。あとから値上げすることはありません。"
                },
                {
                    question: "支払い方法は？", // what payment methods are there
                    answer: "クレジットカード（VISA、Mastercard、American Express、JCB）、Apple Pay、Google Payに対応しています。Apple PayとGoogle Payをお使いの場合、カード番号を入力せずにお支払いいただけます。 一度お支払いいただくと、次回からはメールアドレスだけで決済できるLinkもご利用いただけます。 決済はすべてStripeを通じて、暗号化された状態で安全に処理されます。aomeがカード情報を保持することはありません。"
                },
                {
                    question: "コードを受け取ったのですが、どこで使えますか？", // i received a code, where can i use it
                    answer: "プラン選択の画面に、コードを入力する場所があります。 お勤め先や学校などから配布されたコードをお持ちの場合は、そちらからご利用ください。"
                },
                {
                    question: "解約はいつでもできますか？", // can i cancel at any time
                    answer: "はい。設定画面から、いつでも解約できます。 解約後も、お支払い済みの期間が終わるまではご利用いただけます。新たな請求が発生することはありません。 また戻られたときも、以前の記録はそのまま残っています。"
                },
            ]
        }, {
            name: "使い方", // how to use
            qa: [
                {
                    question: "複数のデバイスで使えますか？", // can i use on multiple devices
                    answer: "はい。スマートフォン、タブレット、パソコン、どれでも同じアカウントでお使いいただけます。記録は自動的に同期されるので、どこからでも続きを始められます。"
                },
            ]
        }, {
            name: "お問い合わせ", // contact us
            qa: [
                {
                    question: "サポートはありますか？", // is there support
                    answer: "メールでいつでもお受けしています。二人で運営しているため、お返事に48時間ほどいただくことがあります。",
                    info: "hello@aome.co.jp"
                },
            ]
        }
    ]

    const qaList = sections.map(s => s.qa).flat()

    const isInteger = (value) =>
        /^-?\d+$/.test(String(value));

    return (
        <div
            className="w-full h-auto lg:h-full flex flex-col gap-8 p-2 lg:p-4 lg:pb-6"
            style={{ maxHeight: isDesktop ? '80vh' : Math.round(vvHeight * 0.8) }}
        >

            <div className="flex gap-2 items-center">
                <span className="">
                    <CircleQuestionMark className='text-base-text size-6' strokeWidth={1} />
                </span>
                <h1 className="text-base-text font-light text-lg w-max">
                    よくある質問
                </h1>
            </div>


            <div className="flex flex-col py-4 gap-3 h-full overflow-y-auto pr-2">
                {(id && isInteger(id) && id < qaList.length && id >= 0) ?
                    <div className="flex flex-col gap-2">
                        <p className="text-base-text font-normal">{qaList[id].question}</p>
                        <p className="text-base-text font-light">{qaList[id].answer}</p>
                    </div>
                    :

                    sections.map((s, si) => (
                        <div className='flex flex-col gap-3' key={si}>
                            <p className="text-base-text font-medium">{s.name}</p>
                            {s.qa.map((faq, qai) => (
                                <div className="flex flex-col gap-2" key={qai}>
                                    <p className="text-base-text font-normal">{faq.question}</p>
                                    <p className="text-base-text font-light">{faq.answer}{faq.info && <><br />{faq.info}</>}</p>
                                </div>
                            ))}
                            {si !== sections.length - 1 && <hr className="h-px my-8 bg-base-text/50 border-0" />}
                        </div>
                    ))

                }

            </div>
        </div>
    )
}